module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/2/5-3a9cbd5c224b5e352e64550a37a421d4.jpg";